import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ENewReviewForm {
  Clear = 'NEW_REVIEW/FORM/CLEAR',
  ClearData = 'NEW_REVIEW/FORM/CLEAR_DATA',
}

export type TNewReviewClear = ITypedReduxAction<ENewReviewForm.Clear>;
export type TNewReviewClearData = ITypedReduxAction<ENewReviewForm.ClearData>;

export const clearNewReviewFormAction = actionGenerator<ENewReviewForm.Clear>(ENewReviewForm.Clear);
export const clearDataNewReviewFormAction = actionGenerator<ENewReviewForm.ClearData>(ENewReviewForm.ClearData);

export type TNewReviewFormActions = TNewReviewClear | TNewReviewClearData;
